import { render, staticRenderFns } from "./response-pattern.vue?vue&type=template&id=b3d9ab18&"
import script from "./response-pattern.vue?vue&type=script&lang=js&"
export * from "./response-pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports